import { t } from '@/ui/i18n/i18n';
import { h } from 'vue';
import { Button } from '@/ui/components/Button';
import { starsIcon } from '@/ui/components/icon/icons';

const onButtonClick = () => {
  window.location.href = process.env.VUE_APP_WEBSITE_URL as string;
};

export const learnMoreButton = (
  { classes = '' }: { classes?: string } = {},
) => {
  return h(Button, {
    props: {
      btnClass: `button button-upgrade ${classes || ''}`,
    },
    on: {
      click: onButtonClick,
    },
  }, [
    starsIcon(),
    t('common.learn-more'),
  ]);
};
